import { memo, useEffect } from "react";

import { Button, ResponsiveFlex } from "@narmi/design_system";

const resetUI = () => {
  document.getElementById("top-menu")?.remove();
  document.getElementById("footer-wrapper")?.remove();
  const elements = document.getElementsByClassName("ui container");
  for (let i = 0; i < elements.length; i += 1) {
    elements[i].remove();
  }
};

type Props = {
  mobileDeepLinkPrefix: string;
};

const MobileEmulation = ({ mobileDeepLinkPrefix }: Props) => {
  const paramsString = window.location.search;
  const searchParams = new URLSearchParams(paramsString);
  const claim_key = searchParams.get("claim_key");

  useEffect(() => {
    resetUI();
  }, []);

  const deepLink = `${mobileDeepLinkPrefix}://emulate/${claim_key}`;

  return (
    <div className="padding--all--l">
      <ResponsiveFlex direction="column">
        <Button label="Start Emulation" onClick={() => window.open(deepLink)} />
        <Button
          startIcon="link"
          kind="secondary"
          label="Copy Link"
          onClick={() => {
            navigator.clipboard.writeText(deepLink);
          }}
        />
      </ResponsiveFlex>
    </div>
  );
};

export default memo(MobileEmulation);
